import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';
import {chestnut} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingTop: 20,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  balance: {
    paddingBottom: 20,
  },
  heading: {
    marginBottom: 10,
    ...getFontFamily('normal'),
  },
  subheading: {
    paddingTop: 40,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItemDate: {
    marginBottom: 4,
  },
  today: {
    color: chestnut,
  },
});
